export default __webpack_public_path__ + "static/media/icons8-linkedin-2.cc7b992c.svg";